export const STAT_IDENTIFIER_TYPES = [
  "RATE",
  "CRUDE_RATE",
  "PERCENTAGE",
  "AVG",
  "COUNT",
  "PERCENT_CHANGE"
];
